// extracted by mini-css-extract-plugin
export var bottomIconImage = "ProvenResults-module--bottomIconImage--cPfO0";
export var bottomResultCard = "ProvenResults-module--bottomResultCard--Y1pAP";
export var bottomResultIcon = "ProvenResults-module--bottomResultIcon--ZBn9J";
export var bottomResultTitle = "ProvenResults-module--bottomResultTitle--2hJi3";
export var bottomResultsGrid = "ProvenResults-module--bottomResultsGrid--zBCWx";
export var description = "ProvenResults-module--description--Q+Cy5";
export var footerSection = "ProvenResults-module--footerSection--TDhvP";
export var footerText = "ProvenResults-module--footerText--j44ZU";
export var headerSection = "ProvenResults-module--headerSection--daYFd";
export var iconImage = "ProvenResults-module--iconImage--P4v4c";
export var mainTitle = "ProvenResults-module--mainTitle--i6-0R";
export var middleSection = "ProvenResults-module--middleSection--Cyb8r";
export var middleTitle = "ProvenResults-module--middleTitle--gKWqk";
export var provenResultsWrapper = "ProvenResults-module--provenResultsWrapper--aq75f";
export var resultCard = "ProvenResults-module--resultCard--0y-6T";
export var resultDescription = "ProvenResults-module--resultDescription--0QA2r";
export var resultIcon = "ProvenResults-module--resultIcon--O0i0N";
export var resultValue = "ProvenResults-module--resultValue--H-DkO";
export var subTitle = "ProvenResults-module--subTitle--uvcLB";
export var topResultsGrid = "ProvenResults-module--topResultsGrid--IVvgv";